// extracted by mini-css-extract-plugin
export default {"dogsContainer":"dogs_dogsContainer__Kaew9","pagination":"dogs_pagination__Ihnri","filters":"dogs_filters__MX-lD","orderAndSearch":"dogs_orderAndSearch__5pr3d"};